import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Show, LiveScheduleList } from 'models';
import { LiveStreamsService } from '../live-streams.service';

export interface ComputedShowSchedule {
  days : string[];
  daysString? : string,
  air_time : string;
  show : Show;
  title : string;
}

@Component({
  selector: 'tyt-live-schedule-block',
  templateUrl: './live-schedule-block.component.html',
  styleUrls: ['./live-schedule-block.component.scss']
})
export class LiveScheduleBlockComponent implements OnInit, AfterViewInit {

  constructor(
    private liveStreamsService : LiveStreamsService
  ) { }

  liveSchedule : LiveScheduleList[];
  activeIndex : number = 0;

  interval = null;

  @ViewChild('track', { read: ElementRef, static: true })
  trackElement : ElementRef;

  @ViewChild('box', { read: ElementRef, static: true })
  boxElement : ElementRef;

  get elementWidth() {
    if (!this.trackElement)
      return;

    let element : HTMLElement = this.trackElement.nativeElement;
    let anEvent : HTMLElement = <any>element.querySelector('.event');

    if (!anEvent)
      return;

    return anEvent.offsetWidth;
  }

  async goToNext() {
    this.activeIndex += 1;
    this.scrollToSelectedElement();
  }

  async goToPrevious() {
    this.activeIndex -= 1;
    this.scrollToSelectedElement();
  }

  async scrollToSelectedElement() {
    if (!this.trackElement) {
      return;
    }

    let element : HTMLElement = this.boxElement.nativeElement;

    if (!element) 
      return;

    let boxWidth = element.offsetWidth;
    let elementWidth = this.elementWidth;
    let padding = 16;


    let pos = this.activeIndex * (this.elementWidth + padding * 2);
    element.scroll({ 
      behavior: 'smooth', 
      left: pos
    });
  }

  async ngAfterViewInit() {
    let waitUntil = 0;

    let boxElement : HTMLElement = this.boxElement.nativeElement;

    boxElement.addEventListener('scroll', () => {
      waitUntil = new Date().getTime() + 1000 * 0.5;
    });

    if (typeof window !== 'undefined') {
      this.interval = setInterval(() => {
        if (!this.trackElement)
          return;
        
        if (!this.liveSchedule)
          return;

        let element : HTMLElement = this.boxElement.nativeElement;
        let elementWidth = this.elementWidth;
        let padding = 16;

        let scrollLeft = element.scrollLeft;

        let item = Math.round(scrollLeft / (this.elementWidth + padding * 2));

        if (item >= this.liveSchedule.length) {
          item = this.liveSchedule.length - 1;
        } else if (item < 0) {
          item = 0;
        }

        let now = new Date().getTime();

        this.activeIndex = item;

        if (waitUntil < now) {

          let pos = this.activeIndex * (this.elementWidth + padding * 2);

          if (scrollLeft != pos) {
            element.scroll({ 
              behavior: 'smooth', 
              left: pos
            });
          }
        }
      }, 100);
    }
  }

  async ngOnInit() {
    this.liveSchedule = await this.liveStreamsService.getSchedule();
    let showMap = {};

    for (let dayItem of this.liveSchedule) {
      let day = dayItem.day;

      for (let item of dayItem.live_schedules) {
        let key = null;

        if (item.show) {
          key = `${item.show.id}@${item.air_time}`;
        } else {
          key = `${item.title}@${item.air_time}`;
        }

        if (!showMap[key]) {
          showMap[key] = {
            days: [],
            show: item.show,
            title: item.title,
            air_time: item.air_time
          }
        }

        showMap[key].days.push(day);
      }
    }

    this.showSchedule = Object.keys(showMap).map(x => showMap[x]);

    for (let schedule of this.showSchedule) {
      let dayString = schedule.days.map(x => this.capitalizeFirstLetter(x)).join(',');

      if (schedule.days.length == 1) {
        dayString = this.capitalizeFirstLetter(schedule.days[0]);
      } else {
        dayString.replace(/Monday,Tuesday,Wednesday,Thursday,Friday/, 'M-F');
        dayString.replace(/Monday,Tuesday,Wednesday,Thursday/, 'M-Th');
        dayString.replace(/Tuesday,Wednesday,Thursday,Friday/, 'T-F');
        dayString.replace(/Wednesday,Thursday,Friday/, 'W-F');
        dayString.replace(/Thursday,Friday/, 'R-F');
        dayString = dayString.replace(/Thursday/g, 'R').replace(/[a-z]/g, '');
      }

      dayString = dayString.replace(/,/g, ', ');
      schedule.daysString = dayString;
    }
  }

  capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
  }

  showSchedule : ComputedShowSchedule[];

}
